require([
        'app',
        'i18next',
        'njs!apps/login/templates/includes/_suggestion',
        'common/components/nunjucks-config/main',
        'vendor/jquery-emoji-picker/jquery.emojipicker',
        'node_modules/backbone/backbone-min'
    ], function (app, i18next, suggestionTemplate, nunjucksConfig, emojiPicker, backbone) {
    'use strict';

    // vars
    var globalDomains = initData.de_global_domains;
    var nextUrl = initData.next_url || '';
    var nextUrlEncoded = window.encodeURIComponent(nextUrl);

    var signinParams = new URLSearchParams(initData.signin_params || {}).toString();

    var doRedirect = !!initData.do_redirect;
    var defaultRedirectUrl = initData.default_redirect_url || '';
    var releaseMessage = ""; // Add text here to display in topMessage
    var releaseMessageDismissed = sessionStorage.getItem('release-message-dismissed') === "true";

    var apiPath = initData.api_path;
    var params = '';
    var deSignInRoleKey = 'deSignInRole';

    var hashEncoded;

    if (window.location.hash) {
        hashEncoded = window.location.hash.replace(/#/g, '%23');

        var obj = {
            "page": "Sign In",
            "url": window.location.href.replace(/#/g, '%23')
        };

        // Update the "next" input value to include the hash (not encoded)
        var nextInputValue = $('input[name=next]').val();
        $('input[name=next]').val(nextInputValue + window.location.hash);

        // Update url history and current url in browser with url with encoded hash tag
        history.pushState(obj, obj.page, obj.url);

        // Appends the encoded hash to the end of the SSO anchor tag href value
        $('.de-login--oauth').attr("href", function() {
            return $(this).attr("href") + hashEncoded;
        });
    }

    if (signinParams) {
        params += '?' + signinParams;
    }

    if (nextUrl) {
        params += (params ? '&' : '?') + 'next_url=' + nextUrlEncoded;
    }

    apiPath = apiPath + params;


    var requestSettings = {
        "dataType": "json",
        "xhrFields": {
            "withCredentials": true
        },
        "crossDomain": true
    };

    var locale = window.initData.locale;
    if (locale && locale !== "en") {
        var baseURL = app.get_path('edde_static') || '/static/';

        $.getJSON(baseURL + 'common/components/nunjucks-config/localization/' + locale.toLowerCase() + '.json', function(messages) {
            nunjucksConfig.init(init, messages, locale);
        });
    } else {
        nunjucksConfig.init(init);
    }

    function init() {
        checkSignInRoleLocalStorage();

        // login form is disabled by default to avoid having users
        //  without javascript attempt to login. If javascript is enabled,
        //  lets enable the input fields, enable buttons, and update button
        //  styles immedaitely.
        var $signInForm = $('.de-login-2020__signin-form');

        $signInForm
            .find('input')
            .attr('disabled', false);

        $signInForm
            .find('button')
            .attr('disabled', false)
            .removeClass('comet-button--disabled');

        attachDOMEventListeners();
        sendAPIRequests();
    }

    function attachDOMEventListeners() {
        $('input[name="username"]').on('blur', clearFormError);
        $('input[name="password"]').on('blur', clearFormError);
        $('input[name="sso-url-input"]').on('blur', clearFormError);

        $('.de-login-2020__signin-form-username-btn').on('click', validateUsername);
        $('.url-sign-in-button').on('click', showUrlSignInPage);
        $('.de-login-2020__url-back-btn').on('click', showUsernamePassword);
        $('.de-login-2020__message-close-btn').on('click', dismissReleaseMessage);
        $('.avatars-role__anchor').on('click', setSignInRole);

        $('#sso-url-form').submit(onSSOFormSubmit);
    }

    function sendAPIRequests() {
        var apiRequests = [];

        _.each(globalDomains, function (domain, index) {
            var promise = $.ajax(
                domain + apiPath,
                requestSettings
            );

            promise.fail(function (jqxhr, textStatus, error) {
                var err = textStatus + ", " + error;
                window.console.log("Request Failed: " + err);
            });

            apiRequests.push(promise);
        });

        var defer = $.when.apply($, apiRequests);

        defer.done(onSuggestAPISuccess)
             .fail(onSuggestAPIFailure);
    }

    function onSuggestAPISuccess() {
        // CONSOLIDATED/MAPPED API RESPONSES

        var apiResults = parseResponses(arguments);

        var countryName,
            finalSuggestion,
            suggestionWithLogin,
            suggestionWithoutLogin;

        var coldSuggestionsByCountry = {
            "US": null,
            "UK": null
        };

        _.some(
            apiResults,

            function (result) {
                var suggestCountryName = getCountryName(result.suggest.recommended_origin);
                coldSuggestionsByCountry[suggestCountryName] = result.suggest.cold_recommended;

                if (result.suggest.logged_in) {
                    // Logged-in suggestion
                    // Save the result if we don't already have a recommendation.
                    suggestionWithLogin = suggestionWithLogin || result;
                } else if (result.suggest.recommended) {
                    // Recommended suggestion
                    // Save the result if we don't already have a recommendation.
                    suggestionWithoutLogin = suggestionWithoutLogin || result;
                }

                // break the loop on the first logged-in suggestion
                return !!suggestionWithLogin;
            }
        );

        countryName = suggestionWithLogin ? getCountryName(suggestionWithLogin.suggest.recommended_origin) : null;

        finalSuggestion = suggestionWithLogin || suggestionWithoutLogin || null;

        if (finalSuggestion && finalSuggestion.suggest.recommended_origin === window.location.origin) {
            finalSuggestion = null;
        }

        if (doRedirect) {
            if (finalSuggestion) {
                redirectTo(finalSuggestion.suggest.recommended);
            } else {
                redirectTo(coldSuggestionsByCountry[guessCountryFromLocale()] || defaultRedirectUrl);
            }
        } else if (finalSuggestion) {
            appendSuggestion(
                finalSuggestion,
                countryName
            );
        } else if (releaseMessage && !releaseMessageDismissed) {
            var messageObject = {
                'display_message': releaseMessage
            };

            appendTopMessage(messageObject, false);
            showTopMessage();
        }
    }

    function guessCountryFromLocale() {
        // we don't want to use the 'locale' variable here (comes from initData) because
        // that will only return locales we've localized the app for, which does not
        // include en-ca. See https://github.com/discoveryedu/edde/blob/develop/edde/flask_babel.py
        var osLocale = Intl.DateTimeFormat().resolvedOptions().locale; // eslint-disable-line new-cap
        var browserLocale = navigator.language;

        if (osLocale.toLowerCase() === 'en-gb' || browserLocale.toLowerCase() === 'en-gb') {
            return 'UK';
        }

        return 'US';
    }

    function onSuggestAPIFailure() {
        if (doRedirect) {
            redirectTo(defaultRedirectUrl);
        }
    }

    // functions
    function appendSuggestion(responseObj, countryName) {
        if (responseObj.suggest.recommended) {
            var recommendedURL = responseObj.suggest.recommended;
            var recommendedURLDecoded = window.decodeURIComponent(recommendedURL);
            var recommendedURLDomain = recommendedURLDecoded.replace(/[?#].*/, '');

            if (hashEncoded) {
                // Need to uppend the encoded hash tag to recommendedURL which is coming from the backend.
                recommendedURL = recommendedURL + hashEncoded;
            }

            var message = suggestionTemplate({
                "country_name": countryName,
                "recommended_url_domain": recommendedURLDomain,
                "recommended": recommendedURL,
                "reason": responseObj.suggest.reason || ''
            });

            var messageObject = {
                'html_display_message': message
            };

            appendTopMessage(messageObject, false);
            showTopMessage();
        }
    }

    function appendTopMessage(messageObject, dismissible, msgType) {
        var $topMessageText = $(".de-login-2020__message-content-text");
        var $topMessageCloseButton = $(".de-login-2020__message-close-btn");

        setupTopMessageType(msgType);

        if (messageObject.html_display_message) {
            $topMessageText.html(messageObject.html_display_message);
        } else if (messageObject.display_message || messageObject.message) {
            var message = messageObject.display_message || messageObject.message;
            $topMessageText.text(message);
        }

        dismissible
            ? $topMessageCloseButton.addClass('de-login-2020__message-close-btn-visible').attr("aria-hidden", false)
            : $topMessageCloseButton.removeClass('de-login-2020__message-close-btn-visible').attr("aria-hidden", true);
    }

    function setupTopMessageType(msgType) {
        var $topMessage = $('.de-login-2020__message');

        if (msgType === 'error') {
            $topMessage.removeClass('comet-block-message--warning');
            $topMessage.addClass('comet-block-message--error');
        } else {
            $topMessage.removeClass('comet-block-message--error');
            $topMessage.addClass('comet-block-message--warning');
        }
    };

    function onSSOFormSubmit(event) {
        event.preventDefault();

        var url = $('#sso-url-input').val().trim();

        if (/[-a-zA-Z0-9@:%_\+.~#?&//=]{2,256}\.[a-z]{2,4}\b(\/[-a-zA-Z0-9@:%_\+.~#?&/=]*)?/gi.test(url)) {

            if (!/^http(s)?:\/\//.test(url)) {
                url = "https://" + url;
            }

            var slash_index = url.indexOf('/', 8); // get past the https:// - we're looking for a / after the origin part
            if (slash_index !== -1) {
                // chop off everything except the Origin, if anything is there
                url = url.substr(0, slash_index);
            }

            if (nextUrl) {
                url += "/learn/signin?" + (signinParams ? signinParams + '&' : '') +
                    "next=" + nextUrlEncoded;
            }

            window.location.href = url;

        } else {
            $('#sso-url-input').parent().addClass("comet-form--error");
            showTopMessage();

            var messageObject = {
                'display_message': i18next.t('Make sure to use a valid URL.')
            };

            appendTopMessage(messageObject, true);

        }
    }

    function parseResponses(responses) {
        var apiResults = [];

        // Because we want to use _.each this has to be a proper array
        responses = Array.prototype.slice.call(responses);

        // because if $.when.apply is used with only a single parameter, this doesn't come in as a list. If only one
        // "global domain" is in use, this will come in with responses not being multiple items so we need to make it back
        // into a list. Thanks jQuery.
        if (responses.length && responses[0].suggest) {
            responses = [responses];
        }

        _.each(responses, function (response) {
            var result = response[0];

            apiResults.push(result);
        });

        apiResults.sort(function(a, b) {
            // sort by timestamp, most recent first
            if (a.suggest.timestamp < b.suggest.timestamp) {
                return 1;
            } else if (a.suggest.timestamp === b.suggest.timestamp) {
                return 0;
            } else {
                return -1;
            }
        });

        return apiResults;
    }

    // Login 2020  - Javascript

    /* validate the username */
    function validateUsername(event) {
        event.preventDefault();

        /* TODO: API call to validate username entry and handle redirect / navigation */

        var username = $('#username').val();
        var url = "/learn/username_validation" + window.location.search;

        $.ajax({
            "type": "POST",
            "url": url,
            "data": {
                "username": username
            },
            "headers": {
                "X-Token": initData.username_validation_token,
            },
            "dataType": "json",
            "xhrFields": {
                "withCredentials": true
            },
            "crossDomain": true,
            "success": successValidation,
            "error": failedValidation,
        });
    }

    function successValidation(resp) {
        if (resp.meta.status_code === 200 && resp.data.redirect_url) {
            var redirectUrl = resp.data.redirect_url;

            if (hashEncoded) {
                // Preserves the hash tag when redirecting to suggested login page.
                redirectUrl = redirectUrl + hashEncoded;
            }

            // Redirects user to correct signin location
            window.location.href = redirectUrl;
        } else {
            showPasswordInput(resp.data.emoji_signin_enabled);
        }
    }

    function failedValidation(resp) {
        var messageObject = {};

        if (resp.status === 401) {
            // Errors when Username field is empty OR
            messageObject.display_message = resp.responseJSON.data.message;
        } else if (resp.status === 403) {
            // Error top message when Username is not found.
            messageObject.html_display_message = resp.responseJSON.data.message;
        } else {
            // For other caught failed requests
            messageObject.display_message = i18next.t('Username validation error. Status code: %(code)s. Edde-Request-ID: %(requestId)s',
                {
                    'code': resp.status,
                    'requestId': resp.getResponseHeader('Edde-Request-ID')
                }
            );
        }

        appendTopMessage(messageObject, true, 'error');
        showTopMessage();
    }

    function clearFormError() {
        if ($(this).val().length) {
            $(this).parent().removeClass('comet-form--error');
        }
    }

    function getCountryName(url) {
        if (url.indexOf('discoveryeducation.com') > 0) { return "US"; }
        if (url.indexOf('discoveryeducation.co.uk') > 0) { return "UK"; }

        return "US";
    }

    function showPasswordInput(allowEmojis) {
        if (allowEmojis) {
            $('#password').emojiPicker({
                "iconBackgroundColor": 'transparent',
            });
        }

        $('.de-login-2020__signin-form-username').removeClass('de-login-2020__signin-form-visible').attr('aria-hidden', 'true');
        $('.de-login-2020__signin-form-password').addClass('de-login-2020__signin-form-visible').attr('aria-hidden', 'false');
        $('.de-login-2020__signin-form-password-btn').attr('aria-hidden', 'false');
        $('.de-login-2020__signin-form-password input').focus();

        $('.de-login-2020__signin-form-username-btn').off("click");
    };

    function showUsernameInput() {
        $('.de-login-2020__signin-form-password').removeClass('de-login-2020__signin-form-visible').attr('aria-hidden', 'true');
        $('.de-login-2020__signin-form-username').addClass('de-login-2020__signin-form-visible').attr('aria-hidden', 'false');
        $('.de-login-2020__signin-form-password-btn').attr('aria-hidden', 'true');
        $('.de-login-2020__signin-form-username input').focus();
    };

    /* navigate to URL sign in page */
    function showUrlSignInPage(event) {
        $('.de-login-2020__signin').removeClass('de-login-2020-visible').attr('aria-hidden', 'true');
        $('.de-login-2020__url').addClass('de-login-2020-visible').attr('aria-hidden', 'false');
        showUsernameInput();
    };

    /* navigate back to Username/Password page */
    function showUsernamePassword(event) {
        $('.de-login-2020__url').removeClass('de-login-2020-visible').attr('aria-hidden', 'true');
        $('.de-login-2020__signin').addClass('de-login-2020-visible').attr('aria-hidden', 'false');
        $('.de-login-2020__signin-form-username-btn').on('click', validateUsername);
        sendAPIRequests();
    };

    function showTopMessage() {
        $('.de-login-2020__message').addClass('de-login-2020__message-visible').attr("aria-hidden", false);
    }

    function hideTopMessage() {
        $('.de-login-2020__message').removeClass('de-login-2020__message-visible comet-block-message--warning comet-block-message--error').attr("aria-hidden", true);
    }

    function dismissReleaseMessage() {
        sessionStorage.setItem('release-message-dismissed', true);
        hideTopMessage();
    }

    function redirectTo(url) {
        window.location.href = url;
    }

    function setSignInRole(event) {
        event.preventDefault();

        var role = event.currentTarget.dataset.role;
        localStorage.setItem(deSignInRoleKey, role);
        checkSignInRoleLocalStorage();
    }

    function checkSignInRoleLocalStorage() {
        var signInRole = localStorage.getItem(deSignInRoleKey);

        if (signInRole) {
            /* eslint-disable no-console */
            $('#signin-section').addClass('de-login-2021-visible');
            $('#profiles-section').removeClass('de-login-2021-visible');
            setProfileView(signInRole);
        } else {
            console.log('does not have a role set');
        }
    }

    function setProfileView(profile) {
        if (profile === 'de-student') {
            $('#tab-students').addClass('tabs-button__active');
            $('#tab-educators').removeClass('tabs-button__active');
        } else if (profile === 'de-educator') {
            $('#tab-educators').addClass('tabs-button__active');
            $('#tab-students').removeClass('tabs-button__active');
        }
    }

    // "additonal information" tooltip - for accessibility
    $('.de-login-2020__signin-oauth-additional-info-tooltip').on('mouseover focus', function(){
        $('.comet-tooltip__content.comet-tooltip__content--top').attr("aria-hidden", "false");
    });
});




define("apps/login/main.js", function(){});

